export default {
  getAccounts(state) {
    return state.accounts
  },
}
